import { favoriteListQueryKeys as e } from "./favoriteListQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { favoriteListsApi as n } from "@maat/api-main";
//#region src/favoriteLists/useFavoriteListDetailQuery.ts
var r = (r) => t({
	queryKey: e.detail(r),
	queryFn: () => n.getList(r),
	enabled: !!r
});
//#endregion
export { r as useFavoriteListDetailQuery };
